import { render } from "./MdAttachView.vue?vue&type=template&id=b1f8722a&scoped=true"
const script = {}

import "./MdAttachView.vue?vue&type=style&index=0&id=b1f8722a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f8722a"]])

export default __exports__